import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { BaseRoute } from 'core/models/base-routes';
import { ButtonType, CircleButtonSize } from '../../buttons/button-types';
import { CircleActionButton } from '../../buttons/circle-action-button/circle-action-button';

export const CircleButtonTab = ({ styles, route, size, onClick }: { styles: { [key: string]: string }, route: BaseRoute, size: CircleButtonSize, onClick: (route: BaseRoute) => void }) => {
  const { t } = useTranslation();

  return (
    <li className={styles.listItem} onClick={() => { onClick(route) }}>
      <CircleActionButton
        meta={{
          type: route.isActive ? ButtonType.Primary : ButtonType.Light,
          size: size,
          title: t(`${route?.name}`),
          name: 'download',
          iconName: route?.icon,
        }}
      ></CircleActionButton>
      <div className={styles.circleTabTitle}>{t(`${route?.name}`)}</div>
    </li>
  )
}